/**
 * Every section the app can show, in one list.
 *
 * Visibility is data, not code: hiding a section removes it from the bottom bar, the
 * dashboard and the Other drawer at once, because they all read from here.
 */

export type SectionId =
  | 'budget'
  | 'nutrition'
  | 'health'
  | 'todo'
  | 'cookbook'
  | 'exercise'
  | 'game'
  | 'savings'
  | 'emergency'

export interface SectionDef {
  id: SectionId
  label: string
  route: string
  /** In the bottom bar, or behind the Other drawer. */
  inNav: boolean
}

export const SECTIONS: SectionDef[] = [
  { id: 'budget', label: 'Budget', route: '/budget', inNav: true },
  { id: 'nutrition', label: 'Nutrition', route: '/nutrition', inNav: true },
  { id: 'health', label: 'Health', route: '/health', inNav: true },
  { id: 'todo', label: 'To-do', route: '/todo', inNav: true },
  { id: 'savings', label: 'Savings', route: '/savings', inNav: false },
  { id: 'cookbook', label: 'Cookbook', route: '/cookbook', inNav: false },
  { id: 'exercise', label: 'Exercise tracker', route: '/exercise', inNav: false },
  { id: 'game', label: 'Spinner', route: '/sex-game', inNav: false },
  { id: 'emergency', label: 'Emergency', route: '/emergency', inNav: false },
]

export function isHidden(hidden: string[], id: SectionId): boolean {
  return hidden.includes(id)
}

export function visibleSections(hidden: string[]): SectionDef[] {
  return SECTIONS.filter((s) => !isHidden(hidden, s.id))
}
